import { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { settingServices } from "Utils/setting/services";
import snackbarUtil from "Utils/snackBarUtil";

const AddNewMarket = ({ showAddMarketModal, setShowAddMarketModal, activeTopTab, data }: any) => {
  const [newMarketName, setNewMarketName] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const addNewMarketHandler = async () => {
    if (!newMarketName.trim()) {
      snackbarUtil.error(`Please enter a ${activeTopTab} name.`);
      return;
    }

    try {
      const checkMarket: any = {
        markets: "market",
        fancy: "fancy"
      };
      setIsLoading(true);
      const payload = {
        event_type:checkMarket[activeTopTab],
        market_name: newMarketName.trim(),
        sport_id: data?.sport_id,
      };

      const { response } = await settingServices.addNewMarket(payload);

      if (response?.status) {
        snackbarUtil.success(response?.msg);
        setNewMarketName("");
        setShowAddMarketModal(false);
      } else if(!response?.status) {
        snackbarUtil.error(response?.msg);
      }
    } catch (error) {
      console.error("Add Market Error:", error);
      snackbarUtil.error("Failed to add market. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      show={showAddMarketModal}
      onHide={() => setShowAddMarketModal(false)}
      centered
      className="add-market-modal"
    >
      <Modal.Header style={{ backgroundColor: "#2370b0", color: "white", padding: "10px" }} closeButton>
        <Modal.Title style={{ color: "white" }}>Add New {activeTopTab}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
          <Form.Control
            placeholder={`Enter ${activeTopTab} name`}
            value={newMarketName}
            onChange={(e) => setNewMarketName(e.target.value)}
          />
          <Button
            style={{ background: "#50a5f1", border: "none" }}
            onClick={addNewMarketHandler}
            disabled={isLoading}
          >
            {isLoading ? "Submitting..." : "Submit"}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AddNewMarket;
